import styled, { css } from 'styled-components';

export const FeedbackStatistic = styled.div`
	min-height: 480px;
	overflow: hidden;
`;

export const Title = styled.h5`
	position: absolute;
	top: 20px;
	right: 50%;
	z-index: 1000;
	text-align: center;
	transform: translateX(50%);

	small {
		display: block;
		font-weight: normal;
		margin-top: 5px;
	}
`;

export const List = styled.div`
	width: 100%;
	height: 345px;
	overflow: hidden;
	transition: ${(p) => p.theme.transition.all};
`;

export const Item = styled.div`
	width: 100%;
	float: left;

	h5 {
		margin-bottom: 0.25em;
		text-align: center;
	}

	h6 {
		font-weight: 300;
		color: #737d83;
		margin-bottom: 1em;
		text-align: center;
	}
`;

export const ChartWrapper = styled.div`
	max-width: 80%;
	margin: 0 auto;
`;

export const Chart = styled.figure`
	position: relative;
	display: flex;
	padding: 0 1rem;
	margin: 2rem auto;
	justify-content: space-around;
	height: 220px;

	&:after {
		content: '';
		position: absolute;
		bottom: 55px;
		left: 0;
		right: 0;
		height: 1px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

export const Line = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	text-align: center;
`;

export const ProgressBar = styled.div`
	display: flex;
	margin-bottom: 4px;
	flex-direction: column-reverse;
	flex: 1 1;
`;

export const Indicator = styled.i`
	width: 8px;
	margin: 0 auto;
	display: block;
	border-radius: 8px 8px 0 0;
	min-height: 4px;
	background-image: linear-gradient(90deg, #1ece8e 0%, #1eceaf 100%);

	height: ${(p) => p.$percent}%;
`;

export const Percent = styled.span`
	font-size: 14px;
	color: #333;
`;

export const Emoji = styled.img`
	width: 32px;
	height: 32px;
	display: inline-block;
	vertical-align: middle;
	margin: 0 0.35em;
`;

export const Count = styled.p`
	font-size: 12px;
	color: #868f94;
`;

export const ArrowHolder = styled.div``;

export const ArrowButton = styled.button`
	cursor: pointer;
	position: absolute;
	top: 50%;
	border: 0;
	background: #fff;
	border-radius: 100%;
	width: 42px;
	height: 42px;
	transform: translateY(25%);
	box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);
	padding: 0;
	color: #1eceaf;

	transition: 0.2s ease-in-out;
	z-index: 1;

	${(p) =>
		p.$right &&
		css`
			right: 10px;
		`}

	${(p) =>
		p.$left &&
		css`
			left: 10px;
		`}

  &[disabled] {
		color: #bfbfbf;
		cursor: auto;
	}
`;

export const Description = styled.div`
	font-weight: 300;
	line-height: 1.5;
	color: #787e81;
	margin-bottom: 30px;
	text-align: center;
	padding: 0 25px;
	direction: rtl;
`;

export const BackButton = styled.div`
	text-align: center;
	margin-bottom: 30px;
`;
